import { HelmetProvider, Helmet } from "react-helmet-async";

export const ReactHelmetWithProvider = ({ children, helmetOptions = null }) => {
  return (
    <HelmetProvider>
      <Helmet {...helmetOptions}>{children}</Helmet>
    </HelmetProvider>
  );
};
